import React, { Suspense, useEffect, useContext } from 'react'
import { Route, Routes, Navigate, useNavigate } from 'react-router-dom'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import { ROLE_CA_FLOWS } from 'src/consumer/constants'
import { ClinicDataContext } from 'src/context/ClinicDataContext'

const KioskLayout = React.lazy(() => import('./KioskLayout'))
const KioskSelectFlowPage = React.lazy(() => import('src/clinic/components/KioskSelectFlowPage'))
const ClinicCounterForMentor = React.lazy(() => import('src/clinic/components/ClinicCounterScreen/ClinicCounterForMentor'))

// Component to handle base /kiosk redirect logic
// This replaces the redirect logic that was previously in ClinicLandingPage and CALandingPageModern
function KioskLandingRedirect() {
  const navigate = useNavigate()
  const { assistantData } = useContext(ClinicDataContext)
  
  useEffect(() => {
    // Check kiosk config and redirect accordingly
    // Uses kiosk-config with fallback to ROLE_CA_CONFIG (for backward compatibility)
    const kioskConfigStr = localStorage.getItem('kiosk-config')
    const roleCaConfigStr = localStorage.getItem('ROLE_CA_CONFIG')
    const kioskConfig = kioskConfigStr ? JSON.parse(kioskConfigStr) : (roleCaConfigStr ? JSON.parse(roleCaConfigStr) : {})
    
    if (kioskConfig?.FLOW_ID) {
      if (
        kioskConfig?.FLOW_ID === ROLE_CA_FLOWS.FLOW_APPOINTMENT_SCREEN &&
        kioskConfig?.BRAND_FOR_OOH &&
        kioskConfig?.LOCATION_FOR_OOH &&
        kioskConfig?.MENTOR_FOR_OOH
      ) {
        // Try to get location slug from assistantData if available, otherwise use ID
        const location = assistantData?.associatedClinicsData?.find((l) => l?.id === kioskConfig?.LOCATION_FOR_OOH)
        const locationSlug = location?.slug || kioskConfig?.LOCATION_FOR_OOH
        // Mentor slug/ID - component will handle resolution
        const mentorSlug = kioskConfig?.MENTOR_FOR_OOH
        navigate(`/kiosk/display/${locationSlug}/${mentorSlug}`, { replace: true })
        return
      } else if (
        kioskConfig?.FLOW_ID === ROLE_CA_FLOWS.FLOW_REMOTE_DOCTOR &&
        kioskConfig?.SCREEN_DEVICE_CONFIG_ID &&
        kioskConfig?.CURRENT_VIRTUAL_ROOM_ID
      ) {
        navigate('/kiosk/chamber-screen-home', { replace: true })
        return
      } else {
        // Flow is set but config incomplete, redirect to select-flow
        navigate('/kiosk/select-flow', { replace: true })
        return
      }
    }
    
    // No flow set, redirect to select-flow
    navigate('/kiosk/select-flow', { replace: true })
  }, [navigate, assistantData])
  
  return <LoadingSpinner />
}

export default function KioskRoutesHandler() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        {/* Kiosk-specific routes - moved from primaryRoutes */}
        <Route path="chamber-screen-home/*" element={<KioskLayout />} />
        <Route path="select-flow" element={<KioskSelectFlowPage />} />
        <Route path="display/:location/:mentor" element={<ClinicCounterForMentor />} />
        
        {/* Base /kiosk route - handles redirect logic based on config */}
        <Route path="/" element={<KioskLandingRedirect />} />
        
        {/* Catch-all - redirect to select-flow */}
        <Route path="*" element={<Navigate to="/kiosk/select-flow" replace />} />
      </Routes>
    </Suspense>
  )
}

